import { Pipe, PipeTransform } from '@angular/core';

/**
 * Usage note: make sure that the predicate function is bound to the
 * context of the component in which it is being used (and that it is bound
 * in the component/.ts file, not the template/.html file).
 */
@Pipe({ name: 'find', pure: true })
export class FindPipe implements PipeTransform {
  public transform<T>(arr: T[], predicate: (value: T) => boolean): T | undefined {
    return arr.find(predicate);
  }
}
